function isObject<T>(a: unknown): a is Record<string, T> {
  if (Array.isArray(a)) {
    return false;
  }
  if (a && typeof a === 'string') {
    return false;
  }
  if (a && typeof a === 'object') {
    return true;
  }
  return false;
}

export function isDeepEqual(a: unknown, b: unknown): boolean {
  if (Array.isArray(a)) {
    if (!Array.isArray(b)) {
      return false;
    }

    if (a.length !== b.length) {
      return false;
    }

    return a.every((aValue, i) => {
      const bValue = b[i];
      return isDeepEqual(aValue, bValue);
    });
  }
  if (isObject(a)) {
    if (!isObject(b)) {
      return false;
    }

    const keys = Array.from(new Set([...Object.keys(a), ...Object.keys(b)]).keys());

    return keys.every((key) => {
      if (!(key in a) || !(key in b)) {
        return false;
      }
      const aValue = a[key];
      const bValue = b[key];
      return isDeepEqual(aValue, bValue);
    });
  }
  return a === b;
}
